import React, { useEffect, useContext, useState } from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { getFunds, IFund } from '../../../../common/services/http/fundsService';
import FilterCtx from '../../../../context/filterContext/filterCtx';

import '../../multiselect/multiselect.scss';
import '../filters.scss';
import useTranslate from '../../../../common/hooks/useTranslate';
import { Switch } from '@progress/kendo-react-inputs';

interface Fund {
  title?: string;
  table?: string;
  toggleOn?: boolean;
}

const FundsFilter: React.FC<Fund> = ({ table, toggleOn }) => {
  const { t } = useTranslate();
  const filterCtx: any = useContext(FilterCtx);
  const [value, setValue] = useState<IFund[]>([]);
  const [filterChoice, setFilterChoice] = useState<IFund[]>([]);
  const [cashChoice, setCashChoice] = useState<IFund[]>([]);
  const [checked, setChecked] = useState(false);

  const impersonation = useSelector((state: RootState) => state.impersonate);

  useEffect(() => {
    setChecked(filterCtx.slicerChoices.indexOf('fundName') + 1 > 0);
    getFunds()
      .then((res: IFund[]) => {
        setFilterChoice(res);
        setCashChoice(res);
      })
      .catch((err) => console.log('Funds error: ', err));
    if (table === 'documents' && filterCtx.funds) {
      setValue(filterCtx.funds);
    } else {
      setValue(filterCtx.fundsActivity);
    }
  }, [impersonation]);

  useEffect(() => {
    if (table === 'documents') {
      filterCtx.setFunds(value);
    } else {
      filterCtx.setFundsActivity(value);
    }
  }, [value]);

  const handleFundsToggleChange = (e) => {
    setChecked(e.value);
    filterCtx.setFundsToggle(e.value);
    filterCtx.setFunds([]);
    setValue([]);
    let tempArray = filterCtx.slicerChoices;
    let tempGroupsArray = filterCtx.initialGroup;
    if (e.value) {
      filterCtx.setSlicerChoices([...filterCtx.slicerChoices, 'fundName']);
      filterCtx.setInitialGroup([...filterCtx.initialGroup, { field: 'fundName' }]);
    } else {
      tempArray = filterCtx.slicerChoices.filter((item) => item !== 'fundName');
      tempGroupsArray = filterCtx.initialGroup.filter((item) => item.field !== 'fundName');
      filterCtx.setSlicerChoices(tempArray);
      filterCtx.setInitialGroup(tempGroupsArray);
    }
  };

  const handleFundChange = (event): void => {
    setValue(event.target.value);
  };

  const handleFundsFilterChange = (event: any) => {
    setFilterChoice(filterBy(cashChoice.slice(), event.filter));
  };

  return (
    <div className="funds-filter-wrapper">
      <MultiSelect
        className={toggleOn && checked ? 'multiselect-padding-left' : ''}
        data={filterChoice}
        textField="name"
        dataItemKey="id"
        value={value}
        placeholder={t('FILTERS.FUNDS')}
        filterable={true}
        disabled={toggleOn && checked}
        onChange={handleFundChange}
        onFilterChange={handleFundsFilterChange}
      />
      {toggleOn && checked && filterCtx.slicerChoices.indexOf('fundName') + 1 > 0 && (
        <div className="switch-number-container">
          <span>{filterCtx.slicerChoices.indexOf('fundName') + 1}</span>
        </div>
      )}
      {toggleOn && (
        <div className="switch-container">
          <Switch onLabel={''} offLabel={''} checked={checked} onChange={handleFundsToggleChange} />
        </div>
      )}
    </div>
  );
};

export default FundsFilter;
